<template>
  <b-row v-if="parentPath && path" style="height:100%;margin-bottom:55px">
    <b-col md="12">
      <b-card
        v-tooltip="uniToolTipTranslation('S654', 'en-US')"
        style="margin-bottom:0px;"
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          {{ uniTranslation("TRNSL36") }}
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <button
              v-tooltip="{
                content: uniToolTipTranslation('Q9223', 'en-US'),
                placement: 'right'
              }"
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni,
                width: '48%'
              }"
              type="button"
              class="btn btn-default"
              @click="$emit('setSelection')"
            >
              <i class="fa fa-thermometer-full"></i>
              {{ uniTranslation("TRNSL37") }}
            </button>
            <button
              v-tooltip="{
                content: uniToolTipTranslation('S938', 'en-US'),
                placement: 'right'
              }"
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni,
                width: '48%'
              }"
              type="button"
              class="btn btn-default"
              @click="$emit('setVerify')"
            >
              <i class="fa fa-thermometer-full"></i>
              {{ uniTranslation("TRNSL38") }}
            </button>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PheProjectSelectionDetails from "./PheProjectSelectionDetails.vue";

export default {
  components: {
    PheProjectSelectionDetails
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      pathPlateMaterial: null,
      pathGasketMaterial: null,
      pathFrameMaterial: null,
      isTypeOfPheVisible: true,
      isDesignStandardVisible: true,
      isProductLineVisible: true,
      coloreSfondo: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreTesto: "",
      coloreBordo: "",
      coloreFooterSfondo: "",
      coloreFooterTesto: "",
      coloreFooterBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: "",
      dtml: ["DTMLFisso", "DTMLVariabile"],
      dtmlValue: 0
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors", "footerColors"]),
    modalitaExpert: function() {
      return this.$store.getters.modalitaExpert;
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
      this.pathPlateMaterial = this.path + ".plate";
      this.pathGasketMaterial = this.path + ".gasket";
      this.pathFrameMaterial = this.path + ".frame";

      that.coloreSfondo = that.cardColors[0] + " !important"; // 4 elem: 0=sfondo 1=barra con titolo 2=testo 3=titolo
      that.coloreBarraTitolo = that.cardColors[1]; // 3 elem non usati + altri 2
      that.coloreTesto = that.cardColors[2];
      that.coloreTitolo = that.cardColors[3];
      that.coloreBordo = that.cardColors[6];

      that.coloreFooterSfondo = that.footerColors[0];
      that.coloreFooterTesto = that.footerColors[1];
      that.coloreFooterBottoni = that.footerColors[2] + " !important";
      that.coloreTestoBottoni = that.footerColors[3];
      that.coloreBordoBottoni = that.footerColors[4];
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.card .card-header {
  background-color: transparent;
  padding: 0px;
}

label {
  margin-bottom: 0px;
}

div {
  hr {
    margin-bottom: 10px;
    margin-top: 10px;
    border: solid;
    border-width: 1px;
    width: 90%;
    height: 0px;
    /* Set the hr color */
    color: #333; /* old IE */
    background-color: #333; /* Modern Browsers */
  }
}

.materialSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.materialSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
}
</style>
